import { cancelPreparedPaymentLink, requestActivePaymentLinkCancellation, sendPaymentLink, reverseReceipt, createRefundObligation, withdrawBankTransferReport, transitionCheque, unlockInvoiceV2 } from '../models/paymentsV2Model';
import { usePaymentCommand } from './usePaymentCommand';
import { decimal } from '../utilities/paymentPresentation';
export function useLedgerCommand(projection, key, row, reload) {
  const command = usePaymentCommand(`${key}-${projection.query_pk}-${row?.entity_id || ''}`, () => reload({ silent: true }));
  const receipt = projection.receipts?.find(item => String(item.id) === String(row?.entity_id));
  const intent = projection.payment_link_intents?.find(item => String(item.id) === String(row?.entity_id));
  const cheque = projection.cheques?.find(item => String(item.id) === String(row?.entity_id));
  return { ...command, receipt, intent, submit: values => {
    const reasons = { reason_code: values.reason_code, note: values.note || null };
    const id = row?.entity_id;
    const routes = {
      cancel_link: payload => (intent?.status === 'creating' ? cancelPreparedPaymentLink : requestActivePaymentLinkCancellation)(id, payload),
      resend_link: payload => sendPaymentLink(id, payload),
      reverse: payload => reverseReceipt(id, payload),
      refund: payload => createRefundObligation(projection.invoice.id, payload),
      withdraw_report: payload => withdrawBankTransferReport(id, payload),
      cancel_expected_cheque: payload => transitionCheque(id, 'cancel', payload),
      unlock: payload => unlockInvoiceV2(projection.query_pk, payload),
    };
    const payload = key === 'resend_link' ? { channel: 'auto' } : {
      ...reasons,
      ...(key === 'cancel_link' && intent?.status !== 'creating' ? { expected_version: intent?.version } : {}),
      ...(key === 'reverse' ? { expected_amount: receipt?.amount } : {}),
      ...(key === 'refund' ? { source_receipt_allocation_id: row.detail?.allocation_id, amount: decimal(values.amount), operations_financial_obligation_id: null } : {}),
      ...(key === 'withdraw_report' ? { confirmed_no_funds_sent: true } : {}),
      ...(key === 'cancel_expected_cheque' ? { expected_version: cheque?.version } : {}),
      ...(key === 'unlock' ? { expected_invoice_version: projection.invoice?.version_number } : {}),
    };
    return command.submit(routes[key], payload);
  } };
}
